import axiosClient from './axiosClient';

const rideDemandApi = {
  getDemands: (params) => axiosClient.get('/rides/demands', { params }),
  getDemand: (demandId) => axiosClient.get(`/rides/demands/${demandId}`),
  cancelDemand: (demandId, reason) => axiosClient.post(`/rides/demands/${demandId}/cancel`, { reason }),
};

export default rideDemandApi;
